var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"t-no-format"},[_c('h3',{staticClass:"t-no-format__title",domProps:{"innerHTML":_vm._s(_vm.$root.staticText.noFormat)}}),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_vm.$root.staticText.noFormatText)}})])}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/modals/noFormat.vue?vue&type=template&id=40a78266&
// module id = 1311
// module chunks = 0